
export default function AboutSection() {
  const stats = [
    { number: '500+', label: 'Happy Clients' },
    { number: '5+', label: 'Years Experience' },
    { number: '1000+', label: 'Homes Cleaned' },
    { number: '100%', label: 'Satisfaction Rate' }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl font-bold text-gray-800 mb-6">Why Choose Signature Cleaning?</h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              With years of experience in the cleaning industry, we've built our reputation on 
              delivering exceptional results and outstanding customer service. Our team of trained 
              professionals uses the latest equipment and eco-friendly products to ensure your 
              space is not just clean, but healthy and safe.
            </p>
            
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-team-line text-orange-500 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">Experienced Team</h3>
                  <p className="text-gray-600">Our trained professionals have years of experience and undergo regular training to stay updated with the best cleaning practices.</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-leaf-line text-orange-500 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">Eco-Friendly Products</h3>
                  <p className="text-gray-600">We use environmentally safe cleaning products that are effective yet gentle on your family, pets, and the environment.</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-line text-orange-500 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-2">Fully Insured</h3>
                  <p className="text-gray-600">We are fully licensed, bonded, and insured, giving you complete peace of mind when we're in your space.</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <div 
              className="rounded-2xl shadow-2xl h-96 bg-cover bg-center object-top"
              style={{
                backgroundImage: `url('https://static.readdy.ai/image/b19af0eade33e41a7188165c55b524a9/6173c5e3bff6166a64a39361d1f47f7d.jfif')`
              }}
            ></div>
            <div className="absolute -bottom-8 -left-8 bg-white rounded-2xl shadow-xl p-6">
              <div className="flex items-center space-x-4">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center">
                  <i className="ri-award-line text-orange-500 text-2xl"></i>
                </div>
                <div>
                  <h4 className="text-lg font-bold text-gray-800">Quality Guaranteed</h4>
                  <p className="text-gray-600">100% satisfaction promise</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-4xl font-bold text-orange-500 mb-2">{stat.number}</div>
              <div className="text-gray-600 font-medium">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}